<div class="sp-admin-main">
    <div class="sp-table-row">
        <div class="menu">
            <sp-admin-left-menu [userIsSmartPropertyAdmin]="(userProfile$ | async)?.isSmartPropertyAdmin"></sp-admin-left-menu>
        </div>
        <div class="main"><router-outlet></router-outlet></div>
    </div>
</div>
